import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Auftragsvorlage, MandantSummary } from '../../../../api';
import Button, { ButtonType } from '../../../../components/button/Button';
import InputFieldText from '../../../../components/input/floating-label/input-field/InputFieldText';
import { nameof } from '../../../../utils/objectUtils';
import { checkUserExists } from '../../../../redux/actions/benutzer';
import {
  StateModel,
  StateModel_Auftragserfassung,
  StateModel_Auftragsvorlageerfassung,
} from '../../../../redux/store';
import Toolbar from '../../../../components/toolbar/Toolbar';
import {
  checkVorlageExists,
  createAuftragsvorlage,
  resetAuftragsvorlageerfassung,
  setAuftragsvorlageerfassungField,
  updateAuftragsvorlage,
} from '../../../../redux/actions/auftragsvorlageerfassung';
import Select from '../../../../components/select/Select';
import { toSelectOptions } from '../../../../components/select/SelectModel';
import { UserSessionModel } from '../../../../models/UserSessionModel';
import { buildAuftragPayload } from '../../auftragserfassung/payloadBuilder';
import { WaehrungModel } from '../../../../models/WaehrungModel';
import {
  removeNotifications,
  setNotification,
} from '../../../../utils/notificationUtils';
import { FORM_VALIDATION } from '../../../notification/Notification';
import SliderCheckbox from '../../../../components/slidercheckbox/SliderCheckbox';
import { ConfigModel } from '../../../../models/ConfigModel';

interface Auftragsvorlageerfassungsprops {
  auftragsvorlageerfassung: StateModel_Auftragsvorlageerfassung;
  auftragserfassung: StateModel_Auftragserfassung;
  resetAuftragsvorlageerfassung: () => void;
  checkVorlageExists: (name: string, mandantId?: number) => void;
  setAuftragsvorlageerfassungField: (value: any, fieldName: string) => void;
  close: () => void;
  mandantenByHauptmandant: MandantSummary[];
  createAuftragsvorlage: (
    vorlage: Auftragsvorlage,
    closeHandler: () => void
  ) => void;
  session: UserSessionModel;
  stammWaehrungen: WaehrungModel[];
  updateAuftragsvorlage: (
    id: number,
    vorlage: Auftragsvorlage,
    closeHandler: () => void
  ) => void;
  config: ConfigModel;
}

/**
 * Auftragsvorlageerfassung-Component
 *
 * @returns {JSX.Element} Auftragsvorlageerfassung-Component
 * @constructor
 */
const Auftragsvorlageerfassung = (props: Auftragsvorlageerfassungsprops) => {
  const [selectedMandant, setSelectedMandant] = useState<
    MandantSummary | undefined
  >(undefined);
  const [mandanten, setMandanten] = useState<MandantSummary[]>(
    props.mandantenByHauptmandant
  );
  const [isUpdate, setIsUpdate] = useState(false);

  const inputRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  useEffect(() => {
    focusNameField();
  });

  const focusNameField = () => {
    if (inputRef) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  };

  useEffect(() => {
    setMandanten(props.mandantenByHauptmandant);
  }, [props.mandantenByHauptmandant]);

  useEffect(() => {
    props.setAuftragsvorlageerfassungField(
      selectedMandant,
      nameof<Auftragsvorlage>('mandant')
    );
    props.checkVorlageExists(
      props.auftragsvorlageerfassung.vorlageName,
      selectedMandant?.id
    );
  }, [selectedMandant, isUpdate]);

  useEffect(() => {
    removeNotifications();
    if (props.auftragsvorlageerfassung.exists.length > 0) {
      const notificationText = isUpdate
        ? 'Vorlage aktualisieren'
        : 'Name bereits vorhanden';
      setNotification(
        notificationText,
        [],
        FORM_VALIDATION,
        null,
        nameof<Auftragsvorlage>('vorlageName')
      );
      focusNameField();
    }
  }, [props.auftragsvorlageerfassung.exists, isUpdate]);

  useEffect(() => {
    props.checkVorlageExists(
      props.auftragsvorlageerfassung.vorlageName,
      selectedMandant?.id
    );
  }, [props.auftragsvorlageerfassung.vorlageName]);

  const abbrechen = () => {
    resetAuftragsvorlageerfassung();
    close();
  };

  const close = () => {
    props.close();
  };

  const setVorlageName = (value: string) => {
    props.setAuftragsvorlageerfassungField(
      value,
      nameof<Auftragsvorlage>('vorlageName')
    );
  };

  const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const auftrag = buildAuftragPayload(
      props.auftragserfassung,
      props.stammWaehrungen,
      props.config
    );
    const auftragsVorlage: Auftragsvorlage = {
      auftrag: auftrag,
      mandant: props.auftragsvorlageerfassung.mandant,
      vorlageName: props.auftragsvorlageerfassung.vorlageName,
    };
    if (
      isUpdate &&
      props.auftragsvorlageerfassung.exists.length > 0 &&
      props.auftragsvorlageerfassung.exists[0].id
    ) {
      const auftragsVorlage: Auftragsvorlage = {
        auftrag: auftrag,
        mandant: props.auftragsvorlageerfassung.mandant,
        vorlageName: props.auftragsvorlageerfassung.vorlageName,
      };
      props.updateAuftragsvorlage(
        props.auftragsvorlageerfassung.exists[0].id,
        auftragsVorlage,
        close
      );
    } else {
      props.createAuftragsvorlage(auftragsVorlage, close);
    }
  };

  return (
    <div className={'wrapper-auftragsvorlageerfassung'}>
      <form onSubmit={e => handleSave(e)}>
        <Toolbar>
          <Button
            tooltip={'Speichern'}
            key={0}
            classes={'iconButton'}
            type={ButtonType.submit}
          >
            <i className='far fa-save fa-2x' />
          </Button>
          <Button
            tooltip='Abbrechen'
            classes={'iconButton'}
            key={1}
            onClickHandler={() => abbrechen()}
          >
            <i className='fas fa-times fa-2x color-red' />
          </Button>
          <SliderCheckbox
            value={isUpdate}
            onChangeHandler={setIsUpdate}
            labelActive={<i className='fa fa-sync' />}
            labelInactive={<i className='fas fa-sync' />}
            tooltip={'Vorlage aktualisieren'}
            disabled={false}
          />
        </Toolbar>

        <div id='vorlagename-mandant'>
          <InputFieldText
            id={'vorlagename'}
            label='Name'
            name={nameof<Auftragsvorlage>('vorlageName')}
            classes={'vorlagename'}
            onChangeHandler={value => {
              setVorlageName(value);
            }}
            value={props.auftragsvorlageerfassung.vorlageName}
            ref={inputRef}
            focusAfterTip={focusNameField}
          />
          {props.session.isHauptmandant && (
            <Select
              className='adr-mandant'
              headerTitle='Mandant'
              onChangeHandler={(id?: number) => {
                const mandant = mandanten.find(mandant => mandant.id === id);
                setSelectedMandant(mandant);
              }}
              selectedOptionId={selectedMandant?.id ?? undefined}
              selectData={toSelectOptions(mandanten, 'name')}
            />
          )}
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
  session: state.UserSession,
  mandantenByHauptmandant: state.Stammdaten.mandanten,
  auftragsvorlageerfassung: state.Auftragsvorlageerfassung,
  stammWaehrungen: state.Stammdaten.waehrungen,
  config: state.Config,
});

const mapDispatchToProps = {
  resetAuftragsvorlageerfassung,
  checkUserExists,
  setAuftragsvorlageerfassungField,
  createAuftragsvorlage,
  checkVorlageExists,
  updateAuftragsvorlage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Auftragsvorlageerfassung);
